// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"t4 xm","ribbon":"t5 xv","title":"t6 xo","year":"t7 xp","genres":"t8 xu","duration":"t9","buttonWrapper":"t- xq","button":"t_ xr","price":"ua","upperParts":"ub"};